<template>
    <div class="fileUploader">

        <div v-if="picture && (accept.startsWith('application/pdf') || accept.startsWith('.csv'))" class="fileUploader__fileContainer">
            <div class="uploadedFile">

              <a :href="picture" target="_blank" class="uploadedFile__link">
                <svg><use xlink:href="#filePlain"></use></svg>
                <div class="uploadedFile__name">{{fileName}}</div>
              </a>

              <a v-if="deleteLink" :href="deleteLink" class="uploadedFile__delete"><svg><use xlink:href="#close"></use></svg></a>
              <a v-else="picture" href="#" @click="emptyInput" class="uploadedFile__delete"><svg><use xlink:href="#close"></use></svg></a>
            </div>
        </div>
        <div v-else-if="picture" class="fileUploader__fileContainer">
            <div class="uploadedFile">
              <img :src="picture" alt="">
              <a v-if="deleteLink" :href="deleteLink" class="uploadedFile__delete"><svg><use xlink:href="#close"></use></svg></a>
              <a v-else="picture" href="#" @click="emptyInput" class="uploadedFile__delete"><svg><use xlink:href="#close"></use></svg></a>
            </div>
        </div>

        <label :for="id" v-show="!picture" class="dropArea">
            <svg class="dropArea__icon"><use xlink:href="#upload"></use></svg>
            <h2 class="dropArea__title">{{ picture ? labelSwitch : label }}</h2>
            <p class="section__infos" v-if="instructions"><svg viewBox="0 0 24 24"><use xlink:href="#information"></use></svg>{{instructions}}</p>
            <input :id="id" type="file" :name="name" :accept="accept" :required="required && !picture" @change="createObjectURL($event)" class="dropArea__input">
        </label>

        <p v-if="sizeError" class="fileUploader__error" role="alert">{{ sizeError }}</p>

    </div>
</template>

<style lang="scss" scoped>
.section__infos {
  display: block;
}
.fileUploader {
  background: #ececec;
  border: 2px dashed #57BAD4;
  position: relative;
  padding: 30px;

  &__error {
    color: #C7345C;
    font-weight: bold;
    text-align: center;
    margin: 15px 0 0;
  }
}

.dropArea {
  text-align: center;

  &__icon {
    width: 64px;
    height: 64px;
    margin: 15px;
    fill: #9f9f9f;
  }

  &__title {
    color: #57BAD4;
    margin: 15px;
  }

  &__input {
    background: #000;
    position: absolute;
    top: 0; left: 0; width: 100%; height: 100%;
    opacity: 0;
    cursor: pointer;
  }
}

.uploadedFile {
  position: relative;
  min-width: 160px;

  &__link {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
  }

  &__name {
    display: inline-block;
    background: black;
    color: white;
    border-radius: 50px;
    font-size: 12px;
    padding: 2px 10px;
    margin-top: 1em;
  }

  &__delete {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: black;
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    transform: translate(50%, -50%);

    svg {
      fill: currentColor;
      max-width: 100%;
      width: 16px;
      height: 16px;
    }

    &:hover {
      background: #57BAD4;
    }
  }
}
</style>

<script>
export default {
    props: {
        label: {
            type: String,
            default: 'Ajouter un fichier'
        },
        labelView: {
            type: String,
            default: 'Voir le fichier'
        },
        labelSwitch: {
            type: String,
            default: 'Remplacer le fichier'
        },
        labelRemove: {
            type: String,
            default: 'Supprimer le fichier'
        },
        instructions: String,
        name: {
            type: String
        },
        accept: {
            type: String,
            default: "image/*"
        },
        stored: String,
        deleteLink: String,
        show: {
            type: Boolean,
            default: false,
        },
        elementId: Number,
        elementName: {
            type: String,
            default: 'picture'
        },
        fileName: {
            type: String,
            default: 'Votre fichier'
        },
        required: {
            type: Boolean,
            default: false,
        },
        maxSizeKb: {
            type: Number,
            default: null,
        },
        maxSizeMessage: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            id: null,
            picture: this.stored,
            sizeError: null,
        }
    },
    mounted(){
        this.id = 'file_uploader-' + this._uid
    },
    methods: {
        emptyInput(event) {
          event.preventDefault()
          document.getElementById( this.id ).value = ''
          this.picture = '';
          this.sizeError = null
            this.$emit('picture-deleted', [this.elementId, this.elementName])
        },
        createObjectURL(event) {
            let file = event.target.files[0];

            if (!file) {
                return
            }

            // Reject oversized files before the upload starts: a slow connection
            // would otherwise transfer the whole file only to be refused server side.
            if (this.maxSizeKb && file.size > this.maxSizeKb * 1024) {
                this.sizeError = this.maxSizeMessage
                event.target.value = ''
                this.picture = ''
                this.$emit('picture-deleted', [this.elementId, this.elementName])

                return
            }

            this.sizeError = null
            this.picture = URL.createObjectURL(file);
            this.$emit('picture-changed', [this.elementId, this.elementName, this.picture])
        }
    },
    watch: {
        picture: function(){
          let url = this.picture;
        },
        stored: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            handler (val, oldVal) {
                // do your stuff
                this.picture = val;
            }
        }
    },
}
</script>
